<template>
    <div class="sidebar pe-4 pb-3">
        <nav class="navbar bg-light navbar-light">
            <router-link to="/" class="navbar-brand mx-4 mb-3">
                <h5 class="text-primary"><i class="fa fa-hashtag me-2"></i>My Stock Profile</h5>
            </router-link>
            <div class="navbar-nav w-100">
                <router-link to="/" class="nav-item nav-link"><i><font-awesome-icon icon="fas fa-tachometer-alt" /></i>Dashboard</router-link>
                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon icon="fa-solid fa-chart-line" /></i>Performance</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/performance/summary" class="dropdown-item">Summary</router-link>
                        <router-link to="/performance/returns" class="dropdown-item">Returns</router-link>
                    </div>
                </div>
                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon icon="fa-solid fa-wallet" /></i>Stock</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/stock/list" class="dropdown-item">Stock List</router-link>
                        <router-link to="/stock/analysis" class="dropdown-item">Stock Analysis</router-link>
                        <router-link to="/stock/stock-transaction" class="dropdown-item">Transactions</router-link>
                        <h6 class="dropdown-header">Add</h6>
                        <router-link to="/stock/add" class="dropdown-item">Add Stock</router-link>
                    </div>
                </div>

                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon :icon="['fas', 'money-bill-trend-up']" /></i>Bonds</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/bond/list" class="dropdown-item">Bond List</router-link>
                        <router-link to="/bond/interest-history" class="dropdown-item">Interest History</router-link>
                    </div>
                </div>

                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon :icon="['fas', 'chart-column']" /></i>Tracker</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/tracker/list" class="dropdown-item">Threads</router-link>
                        <router-link to="/tracker/buy-sell" class="dropdown-item">Buy/Sell</router-link>
                    </div>
                </div>

                <!--
                    Backtests carried eleven flat links -- roughly half the
                    sidebar -- with day-to-day operations, reference data and
                    tuning knobs all reading alike. The headers split those
                    three jobs apart; every destination is unchanged.
                -->
                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon :icon="['fas', 'magnifying-glass-chart']" /></i>Backtests</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <h6 class="dropdown-header">Operations</h6>
                        <router-link to="/gap-backtest/shortlist" class="dropdown-item">Gap Fill Shortlist</router-link>
                        <router-link to="/gap-backtest/watchlist" class="dropdown-item">Watchlist</router-link>
                        <router-link to="/gap-backtest/live" class="dropdown-item">Live Paper Trading</router-link>
                        <router-link to="/gap-backtest/day-review" class="dropdown-item">Day Review</router-link>
                        <h6 class="dropdown-header">Data</h6>
                        <router-link to="/gap-backtest/universe" class="dropdown-item">Stock Universe</router-link>
                        <router-link to="/gap-backtest/corporate-events" class="dropdown-item">Corporate Events</router-link>
                        <router-link to="/gap-backtest/data-quality" class="dropdown-item">Data Quality</router-link>
                        <h6 class="dropdown-header">Config</h6>
                        <router-link to="/gap-backtest/settings" class="dropdown-item">Settings</router-link>
                        <router-link to="/gap-backtest/strategy-config" class="dropdown-item">Strategy Config</router-link>
                        <router-link to="/gap-backtest/strategy-lab" class="dropdown-item">Strategy Lab</router-link>
                        <router-link to="/gap-backtest/param-optimizer" class="dropdown-item">Param Optimizer</router-link>
                    </div>
                </div>

                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon icon="fa-solid fa-layer-group" /></i>Investment Plan</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/investment_plan/summary" class="dropdown-item">Summary</router-link>
                        <h6 class="dropdown-header">Add</h6>
                        <router-link to="/investment_plan/add-summary" class="dropdown-item">Add Summary</router-link>
                    </div>
                </div>

                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon :icon="['fas', 'coins']" /></i>Dividend</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/stock/dividend-report" class="dropdown-item">Report</router-link>
                        <h6 class="dropdown-header">Add</h6>
                        <router-link to="/stock/add-dividend" class="dropdown-item">Add Dividend</router-link>
                        <router-link to="/stock/import-dividend" class="dropdown-item">Import Dividend</router-link>
                    </div>
                </div>

                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon icon="fa-solid fa-circle-plus" /></i>Trade</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/trade/dashboard" class="dropdown-item">Dashboard</router-link>
                        <h6 class="dropdown-header">Add</h6>
                        <router-link to="/trade/add" class="dropdown-item">Add Trade</router-link>
                    </div>
                </div>

                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon :icon="['fas', 'industry']" /></i>Sector</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/sector/summary" class="dropdown-item">Summary</router-link>
                        <h6 class="dropdown-header">Add</h6>
                        <router-link to="/sector/add" class="dropdown-item">Add Sector</router-link>
                    </div>
                </div>

                <!--
                    Platforms, Exchanges and the cron list were three separate
                    top-level entries, two of them pointing straight at an
                    /add form. They are all reference data you set up once, so
                    they share one section now.
                -->
                <div class="nav-item dropdown">
                    <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i><font-awesome-icon icon="fa-solid fa-gear" /></i>Setup</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/platform/add" class="dropdown-item">Platforms</router-link>
                        <router-link to="/exchange/add" class="dropdown-item">Exchanges</router-link>
                        <router-link to="/scheduler/crons" class="dropdown-item">Crons</router-link>
                    </div>
                </div>

                <router-link to="/docs" class="nav-item nav-link"><i><font-awesome-icon icon="fa-solid fa-book-open" /></i>Documentation</router-link>
            </div>
        </nav>
    </div>
</template>
<script>
export default {
  name: 'Sidebar-page',
}
</script>
<style scoped>
/* The sidebar's dropdowns are transparent and borderless, so a plain
   dropdown-header disappears into the links it is meant to separate. */
.dropdown-header {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.65;
  padding-bottom: 0.15rem;
  margin-bottom: 0;
}
</style>
